<div
  class="action-group"
  [ngClass]="{
    'flip-on-mobile type-b': env.brandingKey === CustomClients.Vorwerk,
    'actions-container': [CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.SEAT].includes(env.brandingKey),
  }"
>
  <ng-template #default>
    <div class="action-list flex-start" [ngClass]="{ 'justify-between': screenSizeDetectorService.isSmallScreen }">
      <thehubz-asset-bulk-edit
        [bulkEditType]="bulkEditType"
        [assetCount]="filteredList.length"
        [buttonText]="bulkEditButtonText"
        [collectionId]="collectionInfo && collectionInfo._id"
        [collectionPublished]="collectionPublished"
        [collectionOwner]="collectionOwner"
        (toggleSelectAllCheckbox)="selectAll($event.checked)"
        (editAsset)="editAssets($event)"
        (clickRemoveFromCollection)="removeFromCollection($event)"
        (downloadCollection)="downloadClick.emit()"
        (publishCollection)="publishCollection.emit()"
        (unpublishCollection)="unpublishCollection.emit()"
        (addToDashboard)="addToDashboard.emit()"
        (shareCollection)="shareCollection.emit()"
        (deleteCollection)="deleteCollection.emit()"
      ></thehubz-asset-bulk-edit>
    </div>
    <div class="action-list justify-end">
      <sp-search-field
        class="action-item"
        (keyUpInput)="searchTextChanged.emit($event)"
        (clearInput)="clearSearch.emit($event)"
        [placeholder]="searchPlaceholder"
        (addOnEnter)="addOnEnter.emit($event)"
        [searchText]="searchText"
        (toggleMobileSearch)="toggleMobileSearch.emit()"
      ></sp-search-field>
      <div>
        <button mat-flat-button type="button" class="button-primary tags-button" (click)="viewAssetTags.emit()" *ngIf="AnyAsset | can: 'tab.tags'" tourAnchor="assets-tags.anchor">
          <mat-icon class="material-icons-outlined">sell</mat-icon>
          <span class="filter-label-wrapper">
            <span class="filter-label" i18n>Tags</span>
          </span>
        </button>
      </div>
      <div class="action-item">
        <button mat-flat-button class="button-primary keep-label-visible" [matMenuTriggerFor]="filterMenu" #menuTrigger (menuClosed)="restFormField.emit()">
          <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
          <span class="px-2 font-bold whitespace-nowrap"
            >Filter <span *ngIf="appliedFilters">({{ appliedFilters }})</span></span
          >
        </button>
        <mat-menu #filterMenu="matMenu" class="filter-popup-box">
          <ng-template matMenuContent>
            <sp-filter-forms
              [formData]="filterCollectionFormData"
              [filterType]="'asset'"
              [selectedFilterObject]="selectedFilterObject"
              [roles]="['global.library']"
              [resetFilterForm]="formResetter"
              (clickApplyFilter)="onApplyFilters($event)"
              (dropDownChange)="updateFormData.emit($event)"
            >
            </sp-filter-forms>
          </ng-template>
        </mat-menu>
      </div>

      @if (screenSizeDetectorService.isLargeScreen) {
        <div class="action-item">
          <button mat-icon-button [matMenuTriggerFor]="gridMenu">
            <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
          </button>
          <mat-menu #gridMenu="matMenu">
            <ng-template matMenuContent>
              <sp-table-wheel-setting
                (changeView)="changeAssetView($event)"
                [headerType]="selectedViewType === 'list' ? 'collectionAssetList' : 'collectionAssetGallery'"
                [menuObjects]="selectedViewType === 'list' ? assetTableMenuObject : assetGalleryMenuObject"
                [selectedViewType]="assetViewTypeService.getViewType(gridSettingsKeySuffix)"
                [selectedViewSection2]="selectedViewSection2"
                (sortBy)="sortBy.emit($event)"
                [sortByNew]="sortByNew"
                [defaultTableCols]="tableData?.columns"
                [additionalColumns]="tableData?.additionalColumns"
              ></sp-table-wheel-setting>
            </ng-template>
          </mat-menu>
        </div>
      }
    </div>
  </ng-template>

  <ng-template [ngIf]="env.brandingKey === 'vorwerk'" [ngIfElse]="default">
    <div class="actions actions-left">
      @if (screenSizeDetectorService.isLargeScreen) {
        <ng-container *ngTemplateOutlet="vorwerkFilterButton"></ng-container>
      }

      <sp-search-field
        (keyUpInput)="searchTextChanged.emit($event)"
        (clearInput)="clearSearch.emit($event)"
        [placeholder]="searchPlaceholder"
        [searchText]="searchText"
        (addOnEnter)="addOnEnter.emit($event)"
        [mobileSearch]="screenSizeDetectorService.isSmallScreen"
        (toggleMobileSearch)="toggleMobileSearch.emit()"
        class="always-show-input"
      ></sp-search-field>

      @if (collectionInfo && screenSizeDetectorService.isLargeScreen) {
        <thehubz-asset-bulk-edit
          (toggleSelectAllCheckbox)="selectAll($event.checked)"
          [bulkEditType]="bulkEditType"
          [collectionId]="collectionInfo._id"
          [assetCount]="filteredList.length"
          [assetCount]="assetCount"
          [buttonText]="'Multi-edit'"
          [showEditButton]="false"
        ></thehubz-asset-bulk-edit>
      }
    </div>

    <div class="actions actions-right">
      @if (screenSizeDetectorService.isSmallScreen) {
        <ng-container *ngTemplateOutlet="vorwerkFilterButton"></ng-container>
      }

      <thehubz-asset-bulk-edit
        *ngIf="collectionInfo"
        [collectionPublished]="collectionPublished"
        [bulkEditType]="bulkEditType"
        [collectionOwner]="collectionOwner"
        [assetCount]="assetCount"
        [collectionId]="collectionInfo._id"
        (editAsset)="editAssets($event)"
        (publishCollection)="publishCollection.emit()"
        (unpublishCollection)="unpublishCollection.emit()"
        (shareCollection)="shareCollection.emit()"
        (deleteCollection)="deleteCollection.emit()"
        (clickRemoveFromCollection)="removeFromCollection($event)"
        [buttonText]="'Multi-edit'"
        [showSelectAllCheckbox]="screenSizeDetectorService.isSmallScreen"
        (toggleSelectAllCheckbox)="selectAll($event.checked)"
      ></thehubz-asset-bulk-edit>

      @if (screenSizeDetectorService.isLargeScreen) {
        <button mat-icon-button [matMenuTriggerFor]="gridMenu">
          <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
        </button>
        <mat-menu #gridMenu="matMenu">
          <ng-template matMenuContent>
            <sp-table-wheel-setting
              (changeView)="changeAssetView($event)"
              [headerType]="selectedViewType === 'list' ? 'assetList' : 'assetGallery'"
              [menuObjects]="selectedViewType === 'list' ? assetTableMenuObject : assetGalleryMenuObject"
              [selectedViewType]="getSelectedViewType()"
              [selectedViewSection2]="selectedViewSection2"
              (sortBy)="sortBy.emit($event)"
              [sortByNew]="sortByNew"
              [defaultTableCols]="tableData?.columns"
              [additionalColumns]="tableData?.additionalColumns"
            ></sp-table-wheel-setting>
          </ng-template>
        </mat-menu>
      }
    </div>
  </ng-template>
</div>

<ng-template #vorwerkFilterButton>
  <div class="filter-box relative">
    <button mat-flat-button type="button" class="filter-button button-primary" (click)="toggleSidebar()">
      <mat-icon class="material-icons-outlined">filter_alt</mat-icon>

      @if (screenSizeDetectorService.isLargeScreen) {
        <span class="filter-label-wrapper">
          <span *ngIf="!assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)" class="filter-label font-bold" i18n>Show filters</span>
          <span *ngIf="assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)" class="filter-label font-bold" i18n>Hide filters</span>
        </span>
      } @else {
        <span class="filter-label font-bold" i18n>Filters</span>
      }

      <span class="filter-count font-bold" *ngIf="appliedFilters">&nbsp;({{ appliedFilters }})</span>
    </button>
  </div>
</ng-template>
